<template>
  <v-form ref="formulario">
    <div style="min-height:350px;">

      <v-layout wrap>
        <v-flex xs12 lg10 xl8>
          <v-layout wrap>

              <v-col cols="12">
                <provider-title title="Etiquetas"></provider-title>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-card class="kim-card outlined">

                  <v-card-title class="pb-0">
                    <provider-sub-title color="secondary" text="Utilización" />
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" @click="confirmSaveSettings" :loading="savingSettings">
                      <v-icon class="mr-1">mdi-content-save</v-icon>
                      Guardar
                    </v-btn>
                  </v-card-title>

                  <v-card-text>

                    <v-col cols="12" class="mt-0 py-0" >
                      <v-switch
                          color="primary"
                          label="Permitir crear etiquetas"
                          v-model="allow_label_creation"
                          hide-details
                      ></v-switch>
                      <small class="secondary--text">Permite a cualquier usuario crear una nueva etiqueta en caso de necesitarlo</small>
                    </v-col>


                    <v-col cols="12" md="6" lg="5" class="mt-0 pt-0" >
                      <v-switch
                          color="primary"
                          label="Permitir uso en citas"
                          v-model="allow_labels_on_appointments"
                          hide-details
                      ></v-switch>
                    </v-col>

                    <v-col cols="12" md="6" lg="5" class="mt-0 pt-0" >
                      <v-switch
                          color="primary"
                          :label="`Permitir uso en ${clientPlural.toLowerCase()}`"
                          v-model="allow_labels_on_clients"
                          hide-details
                      ></v-switch>
                    </v-col>
                  </v-card-text>

                </v-card>
              </v-col>

            <v-flex xs12 mt-4>
              <v-row >
               <v-col cols="12">
                 <v-card class="kim-card flat" color="secondary-card" max-width="800">
                   <v-card-title>
                     <provider-sub-title color="secondary" text="Agregar etiqueta" />
                     <v-spacer></v-spacer>
                     <v-btn  :loading="loadingSave" @click="createLabel" :disabled="!valid" small color="secondary" depressed>
                       <v-icon  size="18" class="mr-1">mdi-plus</v-icon>
                       agregar
                     </v-btn>
                   </v-card-title>
                   <v-card-text>
                     <v-row  justify="center" align="center">
                       <v-col cols="12" md="2" class="text-center">
                         <kyra-color-picker
                             :btn-width="isMobile ? '100%' : '80px'"
                             :show="showColorPicker"
                             :value="labelColor"
                             :close="showColorPicker = false"
                             @change="labelColor = $event"
                         />
                       </v-col>
                       <v-col cols="12" md="6">
                         <v-text-field
                             outlined
                             dense
                             hide-details
                             @input="labelDescription = $event"
                             :value="labelDescription | lowercase"
                             label="Nombre"
                             placeholder='Ej. "Pendiente", "Muestra de exámenes"... '
                             clearable
                         ></v-text-field>
                       </v-col>

                       <v-col cols="12" md="4">
                         <v-select outlined dense hide-details label="Para usar en" v-model="labelType" :items="labelTypes" />
                       </v-col>
                     </v-row>
                   </v-card-text>
                 </v-card>
               </v-col>

                <v-col cols="12">
                  <v-progress-linear indeterminate v-if="loadingLabels" height="2" color="accent" />
                  <v-slide-y-transition>
                    <v-card flat outlined>
                      <v-card-text>
                        <v-row v-show="!loadingLabels">

                          <v-col cols="12" class="pt-2">
                            <provider-sub-title class="mb-2" :text="`Etiquetas para uso en ${clientPlural.toLowerCase()}`" />

                            <div class="my-2" v-if="!loadingLabels && clientLabels.length === 0">Aún no se han creado etiquetas</div>

                            <template  v-for="(label) in clientLabels" >
                              <v-chip label class="kim-label" :key="label.id" :color="label.color">
                                <span :style="{color: label.textColor}">{{label.description}}</span>
                                <v-icon @click.stop="deleteLabel(label)" right :color="label.textColor">close</v-icon>
                              </v-chip>
                            </template>
                          </v-col>

                          <v-flex xs12 my-1>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-col cols="12" class="pt-2">

                            <provider-sub-title class="mb-2" text="Etiquetas para uso en citas" />

                            <div class="my-2" v-if="!loadingLabels && eventsLabels.length === 0">Aún no se han creado etiquetas</div>

                            <template  v-for="(label) in eventsLabels" >
                              <v-chip label  class="kim-label"  :key="label.id" :color="label.color">
                                <span :style="{color: label.textColor}">{{label.description}}</span>
                                <v-icon @click.stop="deleteLabel(label)" right :color="label.textColor">close</v-icon>
                              </v-chip>
                            </template>
                          </v-col>


                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-slide-y-transition>
                </v-col>

              </v-row>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
          <v-card-title>Eliminar etiqueta</v-card-title>
          <v-card-text class="text-center">
            <p class="mb-1">¿Seguro(a) que deseas eliminar esta etiqueta?</p>
            <v-chip v-if="labelToDelete" label :style="{border: `1px solid #ccc`}" :color="labelToDelete.color">
              <span :style="{color: labelToDelete.textColor}">{{labelToDelete.description}}</span>
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="loadingDelete" small @click="dialog = false">Cancelar</v-btn>
            <v-btn small color="error" :loading="loadingDelete" @click="confirmLabelDelete">Sí, eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

  </v-form>
</template>

<script>

  import {mapState, mapMutations, mapActions} from 'vuex'
  import {ApiUtils} from '@/utils/ApiUtils'
  import KyraColorPicker from "@/components/common/KyraColorPicker";
  import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";

export default {
  components: {
    KyraColorPicker,
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    ProviderSubTitle: () => import('@/components/providers/panel/ProviderSubTitle'),
  },
  mixins: [ProviderSettingsMixin],
  props: {
    defaultName: {
      type: String
    }
  },
  data() {
    return {
      allow_labels_on_appointments: false,
      allow_labels_on_clients: false,
      allow_label_creation: false,
      showColorPicker: false,
      labelDescription: '',
      labelColor: '#FFFFFF',
      labelType: 'event',
      loadingSave: false,
      loadingDelete: false,
      labelToDelete: null,
      dialog: false
    }
  },
  watch: { },
  async mounted() {
    var vm = this

    if(vm.currentProviderSettings){
      vm.allow_label_creation = vm.currentProviderSettings.allow_label_creation
      vm.allow_labels_on_appointments = vm.currentProviderSettings.allow_labels_on_appointments
      vm.allow_labels_on_clients = vm.currentProviderSettings.allow_labels_on_clients
    }

    if(vm.labels.length === 0){
      await vm.fetchLabels()
    }

    if(this.defaultName){
      this.labelDescription = this.defaultName
    }

  },
  computed: {
    ...mapState([
        'currentUser',
        'currentProvider',
        'labels',
        'loadingLabels'
    ]),
    valid(){
      const vm = this
      return vm.labelDescription
      && vm.labelColor
      && vm.labelType
    },

    items(){
      const vm = this
      const tinycolor = require("tinycolor2");
      return vm.labels.map(label => {
        label.textColor = tinycolor(label.color).isLight() ? '#000000' : '#FFFFFF'
        return label
      })
    },

    clientLabels(){
      const vm = this
      return vm.items.filter(label => label.type === 'client')
    },

    eventsLabels(){
      const vm = this
      return vm.items.filter(label => label.type === 'event')
    },

    labelTypes(){
      return [
        {
          text: 'Clientes',
          value: 'client'
        },
        {
          text: 'Citas',
          value: 'event'
        },
        {
          text: 'Todo',
          value: 'all'
        }
      ]
    },
    bgColorPicker(){
      return this.$vuetify.theme.primary
    }
  },
  methods: {
    ...mapActions(['fetchLabels']),
    ...mapMutations(['showSnackBar']),
    async confirmSaveSettings(){
      const vm = this
      const payload = {
        allow_labels_on_appointments: vm.allow_labels_on_appointments ? 1 : 0,
        allow_labels_on_clients: vm.allow_labels_on_clients ? 1 : 0,
        allow_label_creation: vm.allow_label_creation ? 1 : 0,
      }

      const settingsSaved = await vm.saveSettings(payload);
      if(settingsSaved){
        return  vm.toast('Configuración guardada')
      }

      vm.toast('Error guardando configuración', 'error')


    },
    deleteLabel(label){
      const vm = this
      vm.labelToDelete = label
      vm.dialog = true
    },
    async confirmLabelDelete(){
      const vm = this
      if (!vm.labelToDelete) return
      const { id } = vm.labelToDelete
      if (vm.loadingDelete || !id) return

      vm.loadingDelete = true
      const response = await ApiUtils.makeDelete(`provider/labels/${id}`)

      if (response.ok){
        vm.dialog = false
        await vm.fetchLabels()
        const json = await response.json()
        vm.showSnackBar({
          text: 'Etiqueta eliminada',
          color: 'success'
        })
        vm.$emit('deleted')
        vm.labelToDelete = null
      }else{
        const json = await response.json()
        return vm.showSnackBar({
          text: 'Error eliminando etiqueta: ' + json.message,
          color: 'error'
        })
      }
      vm.loadingDelete = false

    },

    async createLabel() {

      var vm = this

      const { id } = vm.currentProvider
      if (vm.loadingSave || !id) return

      vm.loadingSave = true
      let response

      response = await ApiUtils.makePost(`providers/${id}/label`, {
        description: vm.labelDescription.toLowerCase(),
        color: vm.labelColor,
        type: vm.labelType,
      })

      vm.loadingSave = false

      if (response.ok){
        await vm.fetchLabels()
        const json = await response.json()
        vm.showSnackBar({
          text: 'Etiqueta creada',
          color: 'success'
        })
        vm.$emit('created', json.result.label)
      }else{
        const json = await response.json()
        return vm.showSnackBar({
          text: 'Error creando etiqueta: ' + json.message,
          color: 'error'
        })
      }

      vm.labelDescription = ''
      vm.labelColor = '#FFFFFF'

    }
  }
}
</script>
<style scoped>

.kim-label{
  border-radius: 8px;
  border: 1px solid #ccc !important;
  margin: 2px 5px;
}

  .mobile-trigger >>>.vue-swatches__trigger__wrapper{
    width: 100% !important;
  }
  >>>.v-datatable__actions{
    display: none;
  }

.ancho {
  max-width: 300px;
}
</style>
